import api from 'api'
import { FormCreation } from 'contexts/CampaignFormContext'
import { CardStatus } from 'components/Layout/Card'
import { store } from '../../store'
import { campaignFormActions } from '../../pages/Campaign/store/campaign-form-slice'

export default class CampaignFormContextService {
  static updateCreationDetails = (creation: FormCreation): Promise<void> | void => {
    const { id: creationId, details } = creation
    if (!details) {
      return
    }

    store.dispatch(campaignFormActions.setCardStatus({ creations: CardStatus.SAVING }))
    return api.creation
      .updateCreationDetails({ creationId, details })
      .then(data => {
        void store.dispatch(campaignFormActions.setCardStatus({ creations: CardStatus.SAVED }))
        if (data && data.data?.updateCreationDetails.brainState) {
          const brainState = data.data.updateCreationDetails.brainState
          if (brainState) store.dispatch(campaignFormActions.updateBasicsValues({ brainState }))
        }
      })
      .catch(
        () =>
          void store.dispatch(campaignFormActions.setCardStatus({ creations: CardStatus.ERROR }))
      )
  }

  static updateCreationDuration = (creation: FormCreation): Promise<void> | void => {
    const { id: creationId, duration } = creation

    store.dispatch(campaignFormActions.setCardStatus({ creations: CardStatus.SAVING }))
    return api.creation
      .updateCreationDuration({ creationId, duration })
      .then(data => {
        void store.dispatch(campaignFormActions.setCardStatus({ creations: CardStatus.SAVED }))
        if (data && data.data?.updateCreationDuration.brainState) {
          const brainState = data.data.updateCreationDuration.brainState
          if (brainState) store.dispatch(campaignFormActions.updateBasicsValues({ brainState }))
        }
      })
      .catch(
        () =>
          void store.dispatch(campaignFormActions.setCardStatus({ creations: CardStatus.ERROR }))
      )
  }

  static updateCreationEmissionsNumber = (creation: FormCreation): Promise<void> | void => {
    const { id: creationId, impressions } = creation

    store.dispatch(campaignFormActions.setCardStatus({ creations: CardStatus.SAVING }))
    return api.creation
      .updateCreationEmissionsNumber(creationId, impressions)
      .then(data => {
        void store.dispatch(campaignFormActions.setCardStatus({ creations: CardStatus.SAVED }))
        if (data && data.data?.updateCreationImpressions.brainState) {
          const brainState = data.data.updateCreationImpressions.brainState
          if (brainState) store.dispatch(campaignFormActions.updateBasicsValues({ brainState }))
        }
      })
      .catch(
        () =>
          void store.dispatch(campaignFormActions.setCardStatus({ creations: CardStatus.ERROR }))
      )
  }

  static updateCreationPercentageShare = (creation: FormCreation): Promise<void> | void => {
    const { id: creationId, percentageShare } = creation

    // if percentageShare is not a valid number, set percentageShare to null, otherwise change "80" to "0.8"
    const percentageShareValue = isNaN(Number(percentageShare))
      ? null
      : (Number(percentageShare) / 100).toString()

    store.dispatch(campaignFormActions.setCardStatus({ creations: CardStatus.SAVING }))
    return api.creation
      .updateCreationPercentageShare(creationId, percentageShareValue)
      .then(data => {
        void store.dispatch(campaignFormActions.setCardStatus({ creations: CardStatus.SAVED }))
        if (data && data.data?.updateCreationPercentageShare.brainState) {
          const brainState = data.data.updateCreationPercentageShare.brainState
          if (brainState) store.dispatch(campaignFormActions.updateBasicsValues({ brainState }))
        }
      })
      .catch(
        () =>
          void store.dispatch(campaignFormActions.setCardStatus({ creations: CardStatus.ERROR }))
      )
  }

  static updateCreationAudienceNumber = (creation: FormCreation): Promise<void> | void => {
    const { id: creationId, audience } = creation

    store.dispatch(campaignFormActions.setCardStatus({ creations: CardStatus.SAVING }))
    return api.creation
      .updateCreationAudienceNumber(creationId, audience)
      .then(data => {
        void store.dispatch(campaignFormActions.setCardStatus({ creations: CardStatus.SAVED }))
        if (data && data.data?.updateCreationAudience.brainState) {
          const brainState = data.data.updateCreationAudience.brainState
          if (brainState) store.dispatch(campaignFormActions.updateBasicsValues({ brainState }))
        }
      })
      .catch(
        () =>
          void store.dispatch(campaignFormActions.setCardStatus({ creations: CardStatus.ERROR }))
      )
  }

  static updateCreationFrequency = (creation: FormCreation): Promise<void> | void => {
    const { id: creationId, frequency } = creation

    store.dispatch(campaignFormActions.setCardStatus({ creations: CardStatus.SAVING }))
    return api.creation
      .updateCreationFrequency(creationId, frequency ?? null)
      .then(data => {
        void store.dispatch(campaignFormActions.setCardStatus({ creations: CardStatus.SAVED }))
        if (data && data.data?.updateCreationFrequency.brainState) {
          const brainState = data.data.updateCreationFrequency.brainState
          if (brainState) store.dispatch(campaignFormActions.updateBasicsValues({ brainState }))
        }
      })
      .catch(
        () =>
          void store.dispatch(campaignFormActions.setCardStatus({ creations: CardStatus.ERROR }))
      )
  }

  static updateCreationContainsAlcohol = (creation: FormCreation): Promise<void> | void => {
    const { id: creationId, containsAlcohol } = creation

    store.dispatch(campaignFormActions.setCardStatus({ creations: CardStatus.SAVING }))
    return api.creation
      .updateCreationContainsAlcohol({ creationId, containsAlcohol })
      .then(data => {
        void store.dispatch(campaignFormActions.setCardStatus({ creations: CardStatus.SAVED }))
        if (data && data.data?.updateCreationContainsAlcohol.brainState) {
          const brainState = data.data.updateCreationContainsAlcohol.brainState
          if (brainState) store.dispatch(campaignFormActions.updateBasicsValues({ brainState }))
        }
      })
      .catch(() => {
        void store.dispatch(campaignFormActions.setCardStatus({ creations: CardStatus.ERROR }))
      })
  }
}
